import accountService from '../../services/account';
import moment from 'moment';
import mixin from '../../mixins/mixin';
import Vue from 'vue';

export default {
  data() {
    return {
      rental: {},
      bookingDetail: {},
      pricePerNight: '',
      duration: '',
      loading: true,
      lang: this.$route.params.lang || 'fr',
    };
  },
  mixins: [mixin],
  components: {
    VLoading: require('components/loading/loading.vue'),
  },
  async mounted() {
    await accountService.getRentalInfo(this, this.$route.params.propertyKey);
    Vue.config.lang = this.lang;
    if (this.rental.web_settings) {
      if (this.rental.web_settings.google_pixel_thank_you) {
        const text = this.rental.web_settings.google_pixel_thank_you.match(/<script>([\s\S]*?)<\/script>/);
        const body = document.getElementsByTagName('body')[0];
        const script = document.createElement('script');
        if (text) {
          script.innerText = text[1];
          body.appendChild(script);
        }
      }
    }
    this.loading = false;
    moment.locale('fr');
    const params = this.$route.params;
    this.bookingDetail.checking = moment(params.checkin, 'YYYY-MM-DD').format('ll');
    this.bookingDetail.checkout = moment(params.checkout, 'YYYY-MM-DD').format('ll');
    this.bookingDetail.price = Number(params.price);
    this.bookingDetail.city_taxes = Number(params.tax);
    this.bookingDetail.nbr_adults = Number(params.adultsCount);
    this.bookingDetail.nbr_children = Number(params.childrenCount);
    this.bookingDetail.promoType = this.$route.query.promoType || null;
    this.bookingDetail.amount = Number(this.$route.query.amount) || null;
    this.bookingDetail.initialPrice = Number(this.$route.query.initialPrice);
    this.duration = Number(params.duration);
    this.pricePerNight = parseFloat(this.$route.query.initialPrice / params.duration).toFixed(2);
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/external-availability/confirmation.js